import { Input } from "@angular/core";
import { Component } from "@angular/core";
import * as Models from "../../service-charges.model";
import { ServiceService } from "../../chargeser.service";
import { ActivatedRoute, Router } from "@angular/router";
import { NotifierService } from "src/app/_services/notifier.service";
import { Subject, Subscription } from "rxjs";
import { take } from "rxjs/internal/operators/take";
import { SimpleChanges } from "@angular/core";
import { debounceTime } from "rxjs/internal/operators/debounceTime";
import { MonthlyExpandService } from "../../../monthlybilling.service";
import { Output } from "@angular/core";
import { EventEmitter } from "@angular/core";
type WeeklyPaginatedService = {
  product_name: string;
  service_name: string;
  costs: { week: string; base: string | number; final: string | number }[];
  regions: {
    region: string;
    costs: { week: string; base: string | number; final: string | number }[];
    product_families: {
      name: string;
      costs: { week: string; base: string | number; final: string | number }[];
    }[];
    expanded?: boolean;
  }[];
  expanded?: boolean;
};

@Component({
  selector: "weekly-component",
  templateUrl: "./weekly.component.html",
  styleUrls: ["./weekly.component.css"],
})
export class WeeklyComponent {
  @Input() monthYear: any;
  @Input() accountId: any;
  @Input() regionId: any;
  @Input() isExpandedAll: any;
  market_isExpandedAll: boolean = false;
  @Output() monthlyData = new EventEmitter<{
    services: any[];
    total: number;
    totser: number;
  }>();
  @Input() filteredTag: any;
  @Input() searchTerm: any;
  market_searchTerm: any;
  accountOptions: { id: number; name: string }[] = [];

  selectedAccountIds: any = [];

  breakpoints = {
    region: false,
    product_family: false,
    line_item: false,
  };

  gear: boolean = false;
  currentPage = 1;
  market_currentPage = 1;
  pageSizeOptions = [20, 50, 100];

  filterTags = false;

  headers: Models.Header[] = [
    { key: "product_code", label: "Service Name", sortable: true },
    { key: "usage", label: "Usage", sortable: false },
    { key: "base_cost", label: "Public Cost (USD)", sortable: true },
    { key: "final_cost", label: "Final Cost (USD)", sortable: true },
  ];
  prevMonth: any = [];
  services: Models.Service[] = [];
  sortKey: Models.SortableColumn = "product_code";
  // searchTerm = "";
  filter = "";
  sortDirection: "asc" | "desc" = "asc";
  total: any;
  totactiveser: any = 0;
  market_totactiveser: any = 0;
  // filteredList: Models.Service[] = [];
  filteredList: WeeklyPaginatedService[] = [];
  funRef: any = {};
  currentMessage!: Subscription;
  // filteredTag: { accountId: string; tagKey: string; tagValue: string } | null =
  //   null;
  selectedPageSize = 20;
  market_selectedPageSize: any;
  usagePagination = false;
  preferencesData: {
    pageSize: number;
    wrapLines: boolean;
    usagePagination: boolean;
    visibleColumns: {
      description: boolean;
      usageQuantity: boolean;
      amountUsd: boolean;
    };
    breakpoints: {
      region: boolean;
      product_family: boolean;
      line_item: boolean;
    };
    selectedAccountIds: string[];
  } = {
    pageSize: 20,
    wrapLines: false,
    usagePagination: true,
    visibleColumns: {
      description: true,
      usageQuantity: true,
      amountUsd: true,
    },
    breakpoints: {
      region: false,
      product_family: false,
      line_item: false,
    },
    selectedAccountIds: [],
  };
  chartInstance: any;
  selectedView: any = "weekly";
  weekHeaders: any[] = [];
  servicesTable: WeeklyPaginatedService[] = [];
  graphData: {
    service_name: string;
    week: string;
    final_cost: number;
    base_cost: number;
  }[];
  market_weeksObj: any;
  market_weekKeys: string[];
  market_weekHeaders: any;
  market_servicesTable: WeeklyPaginatedService[];
  market_filteredList: WeeklyPaginatedService[];
  market_total: any;
  graph: any = [];

  constructor(
    public notifier: NotifierService,
    private router: Router,
    private route: ActivatedRoute,
    private service: ServiceService,
    private monthexp: MonthlyExpandService
  ) {}

  ngOnInit(): void {
    this.preferencesData.selectedAccountIds.push(this.accountId);
    this.funRef = {};

    const navigation = this.router.getCurrentNavigation();
    if (!navigation?.extras?.state) {
      this.route.queryParams.pipe(take(1)).subscribe((p): void => {
        const { open, _t, ...fp } = p;
        const b =
          p["breakup"]
            ?.toString()
            .split(",")
            .map((x: any) => x.trim())
            .filter(Boolean) || [];
        const allKeys: (keyof typeof this.preferencesData.breakpoints)[] = [
          "region",
          "product_family",
          "line_item",
        ];

        if (p["tag_key"] && p["tag_value"] && b.length) {
          // set breakpoints
          this.preferencesData.breakpoints = {
            ...this.preferencesData.breakpoints,
            ...b.reduce((acc: any, k: string) => ((acc[k] = true), acc), {}),
          };
          this.filteredTag = {
            accountId: p["account_ids"] || this.accountId,
            tagKey: p["tag_key"],
            tagValue: p["tag_value"],
          };
          this.loadPreferences(fp);
          return;
        }

        if ("mode" in p) {
          allKeys.forEach(
            (k) => (this.preferencesData.breakpoints[k] = b.includes(k))
          );
          this.loadPreferences(fp);
          return;
        }

        if (!("open" in p)) {
          this.load();
          return;
        }

        setTimeout(
          () => this.loadPreferences({ ...fp, account_ids: this.accountId }),
          100
        );
      });
    } else {
      this.load();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    const changedLater = (key: "monthYear" | "accountId"): boolean =>
      !!changes[key] && !changes[key].isFirstChange();

    this.preferencesData = this.getDefaultPreferences();

    if (changes["filteredTag"] && this.filteredTag) {
      // whenever filter changes, reload with new data
      this.onTagsFiltered(this.filteredTag);
    }

    if (changedLater("monthYear") || changedLater("accountId")) {
      this.filteredTag = null;
      this.load(); // call API only when monthYear or accountId changes
    }

    if (changes["searchTerm"] || changes["tableData"]) {
      this.onSearch();
    }

    if (changes["isExpandedAll"] && !changes["isExpandedAll"].isFirstChange()) {
      if (this.isExpandedAll) {
        this.monthexp.toggleWeeklyExpand(this.servicesTable, true);
      } else {
        this.monthexp.toggleWeeklyExpand(this.servicesTable, false);
      }

      // After toggling, update filteredList to reflect changes in UI
      this.deepcopy();
    }
  }

  handlePageSizeChange(newPageSize: number): void {
    this.selectedPageSize = newPageSize;
    this.market_selectedPageSize = newPageSize;
    this.currentPage = 1;
    this.market_currentPage = 1;

    this.deepcopy();

    this.applyFilter(this.searchTerm);
    this.market_applyFilter(this.market_searchTerm);
  }

  toggleExpandAll() {
    this.isExpandedAll = !this.isExpandedAll;
    this.monthexp.toggleWeeklyExpand(this.servicesTable, this.isExpandedAll);
    this.deepcopy();
    this.servicesTable.forEach(
      (s) => (this.productNameExpandedMap[s.service_name] = this.isExpandedAll)
    );
  }
  market_toggleExpandAll() {
  const newState = !this.market_isExpandedAll;
  this.monthexp.toggleWeeklyExpand(this.market_servicesTable, newState);
  this.deepcopy();

  // Use service_name as the key (same as template)
  this.market_servicesTable.forEach(
    (s) => (this.productNameExpandedMap[s.service_name] = newState)
  );

  this.market_isExpandedAll = newState;
}
  productNameExpandedMap: { [key: string]: boolean } = {};

  // Toggle product name expand/collapse
  toggleProductName(product: WeeklyPaginatedService) {
    const isNowExpanded = !this.productNameExpandedMap[product.service_name];
    this.productNameExpandedMap[product.service_name] = isNowExpanded;

    // 🧹 When collapsing product, collapse its services
    if (!isNowExpanded) {
      product.expanded = false;
    }
  }

  // Check if product is expanded
  isProductNameExpanded(product: WeeklyPaginatedService): boolean {
    return !!this.productNameExpandedMap[product.service_name];
  }

  // Toggle service expand/collapse (inside product)
  serexpand(service: any) {
    service.expanded = !service.expanded;
  }

  // Collapse all services under a product
  private collapseServiceLevels(product: any) {
    if (product.services && Array.isArray(product.services)) {
      for (const svc of product.services) {
        svc.expanded = false; // hides regions + product families automatically
      }
    }
  }

  deepcopy() {
    if (!this.servicesTable?.length) {
      this.filteredList = [];
      return;
    }

    this.filteredList = this.servicesTable.map((s) => ({
      product_name: s.product_name,
      service_name: s.service_name,
      costs: s.costs || [],
      expanded: s.expanded, // preserve current state
      regions: (s.regions || []).map((r: any) => ({
        region: r.region,
        costs: r.costs || [],
        expanded: r.expanded, // preserve current state
        product_families: (r.product_families || []).map((pf: any) => ({
          name: pf.name,
          costs: pf.costs || [],
        })),
      })),
    }));
  }

  private async fetchAndBind(
    query: Record<string, any>,
    pushToUrl = true
  ): Promise<void> {
    this.notifier.loading(true);

    try {
      const apiQuery = {
        ...query,
        type: this.selectedView,
      };

      await this.loadViewData(apiQuery, pushToUrl);
      this.deepcopy();
    } catch (err) {
      console.error("Error fetching data:", err);

      this.servicesTable = [];
      this.weekHeaders = [];
      this.filteredList = [];
      this.total = 0;
      this.totactiveser = 0;
      this.market_totactiveser = 0;
      this.prevMonth = [];
    } finally {
      this.notifier.loading(false);
    }
  }

  weekKeys: any;
  weeksObj: any;

  private normalizeToArray(input: any): any[] {
    if (!input) return [];
    if (Array.isArray(input)) return input;
    if (typeof input === "object") return Object.values(input);
    return [];
  }

  private async loadViewData(
    query: Record<string, any>,
    pushToUrl = true
  ): Promise<void> {
    this.notifier.loading(true);
    try {
      const { result, fullQuery } = await this.service.loadData(query);

      // Extract account IDs
      const accountId = Object.keys(
        result?.response?.response?.accounts ?? {}
      )[0];
      const market_accountId = accountId;

      // Extract weeks
      this.weeksObj = result?.response?.response?.aws[0]?.weeks ?? {};
      this.market_weeksObj =
        result?.response?.response?.marketplace[0]?.weeks ?? {};
      this.totactiveser =
        result?.response?.response?.aws[0]?.unique_services_count;
      this.market_totactiveser =
        result?.response?.response?.marketplace[0]
          ?.unique_marketplace_services ?? 0;

      this.weekKeys = Object.keys(this.weeksObj);
      this.market_weekKeys = Object.keys(this.market_weeksObj);

      this.weekHeaders = this.weekKeys.map(
        (k: any) => this.weeksObj[k].billing_period
      );
      this.market_weekHeaders = this.market_weekKeys.map(
        (k) => this.market_weeksObj[k].billing_period
      );

      // Collect all unique services
      const allServiceNames = new Set<string>();
      const market_allServiceNames = new Set<string>();

      this.weekKeys.forEach((weekKey: any) => {
        this.normalizeToArray(this.weeksObj[weekKey].services).forEach((s) =>
          allServiceNames.add(s.service)
        );
      });
      this.market_weekKeys.forEach((weekKey) => {
        this.normalizeToArray(this.market_weeksObj[weekKey].services).forEach(
          (s) => market_allServiceNames.add(s.service)
        );
      });

      // --- AWS Services Table ---
      this.servicesTable = Array.from(allServiceNames).map((serviceName) => {
        let product_name = serviceName; // fallback

        // Week-wise costs
        const serviceCosts = this.weekKeys.map((weekKey: any) => {
          const service = this.normalizeToArray(
            this.weeksObj[weekKey].services
          ).find((s) => s.service === serviceName);

          if (service?.product_name) product_name = service.product_name;

          return {
            week: weekKey,
            base:
              service?.base_cost != null
                ? Number(service.base_cost).toFixed(2)
                : "-",
            final:
              service?.final_cost != null
                ? Number(service.final_cost).toFixed(2)
                : "-",
          };
        });

        // Regions
        const regionMap = new Map<string, any>();
        this.weekKeys.forEach((weekKey: any, weekIndex: any) => {
          const service = this.normalizeToArray(
            this.weeksObj[weekKey].services
          ).find((s) => s.service === serviceName);
          if (!service) return;

          const regions = this.normalizeToArray(service?.regions);
          regions.forEach((r) => {
            if (!r?.region) return;
            const regionName = r.region.trim();

            if (!regionMap.has(regionName)) {
              regionMap.set(regionName, {
                region: regionName,
                costs: this.weekKeys.map((wk: any) => ({
                  week: wk,
                  base: "-",
                  final: "-",
                })),
                product_families: [] as any[],
                expanded: false,
              });
            }

            const regionData = regionMap.get(regionName);

            if (r.base_cost != null || r.final_cost != null) {
              regionData.costs[weekIndex] = {
                week: weekKey,
                base:
                  r.base_cost != null ? Number(r.base_cost).toFixed(2) : "-",
                final:
                  r.final_cost != null ? Number(r.final_cost).toFixed(2) : "-",
              };
            }

            const productFamilies = this.normalizeToArray(r.product_families);
            regionData.product_families = productFamilies.map((pf) => ({
              name: pf.product_family,
              costs: this.weekKeys.map((wk: any) => ({
                week: wk,
                base:
                  pf.base_cost != null ? Number(pf.base_cost).toFixed(2) : "-",
                final:
                  pf.final_cost != null
                    ? Number(pf.final_cost).toFixed(2)
                    : "-",
              })),
            }));
          });
        });

        return {
          product_name,
          service_name: serviceName,
          costs: serviceCosts,
          regions: Array.from(regionMap.values()),
          expanded: false,
        };
      });

      // --- Marketplace Services Table ---
      this.market_servicesTable = Array.from(market_allServiceNames).map(
        (serviceName) => {
          let product_name = serviceName;

          const market_serviceCosts = this.market_weekKeys.map((weekKey) => {
            const market_service = this.normalizeToArray(
              this.market_weeksObj[weekKey].services
            ).find((s) => s.service === serviceName);

            if (market_service?.product_name)
              product_name = market_service.product_name;

            return {
              week: weekKey,
              base:
                market_service?.base_cost != null
                  ? Number(market_service.base_cost).toFixed(2)
                  : "-",
              final:
                market_service?.final_cost != null
                  ? Number(market_service.final_cost).toFixed(2)
                  : "-",
            };
          });

          const regionMap = new Map<string, any>();
          this.market_weekKeys.forEach((weekKey, weekIndex) => {
            const service = this.normalizeToArray(
              this.market_weeksObj[weekKey].services
            ).find((s) => s.service === serviceName);
            if (!service) return;

            const regions = this.normalizeToArray(service?.regions);
            regions.forEach((r) => {
              if (!r?.region) return;
              const regionName = r.region.trim();

              if (!regionMap.has(regionName)) {
                regionMap.set(regionName, {
                  region: regionName,
                  costs: this.market_weekKeys.map((wk) => ({
                    week: wk,
                    base: "-",
                    final: "-",
                  })),
                  product_families: [] as any[],
                  expanded: false,
                });
              }

              const regionData = regionMap.get(regionName);

              if (r.base_cost != null || r.final_cost != null) {
                regionData.costs[weekIndex] = {
                  week: weekKey,
                  base:
                    r.base_cost != null ? Number(r.base_cost).toFixed(2) : "-",
                  final:
                    r.final_cost != null
                      ? Number(r.final_cost).toFixed(2)
                      : "-",
                };
              }

              const productFamilies = this.normalizeToArray(r.product_families);
              regionData.product_families = productFamilies.map((pf) => ({
                name: pf.product_family,
                costs: this.market_weekKeys.map((wk) => ({
                  week: wk,
                  base:
                    pf.base_cost != null
                      ? Number(pf.base_cost).toFixed(2)
                      : "-",
                  final:
                    pf.final_cost != null
                      ? Number(pf.final_cost).toFixed(2)
                      : "-",
                })),
              }));
            });
          });

          return {
            product_name,
            service_name: serviceName,
            costs: market_serviceCosts,
            regions: Array.from(regionMap.values()),
            expanded: false,
          };
        }
      );

      // Assign to filtered lists
      this.filteredList = this.servicesTable?.length
        ? [...this.servicesTable]
        : [];
      this.market_filteredList = this.market_servicesTable?.length
        ? [...this.market_servicesTable]
        : [];
      // Totals
      this.total = result?.response?.response?.aws[0]?.final_cost || 0;
      this.market_total =
        result?.response?.response?.marketplace[0]?.final_cost || 0;

      // Optional: push query to URL
      if (pushToUrl && fullQuery) {
        const params: any = {};
        fullQuery.split("&").forEach((pair) => {
          const [key, value] = pair.split("=");
          if (key && value !== undefined) params[key] = value;
        });
        params["_t"] = Date.now();
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: params,
          replaceUrl: true,
        });
      }
      const weeksObjCopy: any = {};

      Object.keys(this.weeksObj).forEach((weekKey) => {
        const awsWeek = this.weeksObj[weekKey]; // original AWS week
        const marketWeek = this.market_weeksObj[weekKey]; // corresponding marketplace week

        // Create a new week object (copy) so original objects are not mutated
        weeksObjCopy[weekKey] = {
          ...awsWeek,
          services: [
            ...(awsWeek.services || []), // existing AWS services
            marketWeek
              ? {
                  service: "AWS Marketplace", // identifier for marketplace
                  billing_entity: "AWS Marketplace",
                  base_cost: marketWeek.final_cost,
                  final_cost: marketWeek.final_cost,
                  regions: {},
                  product_name: "AWS MarketPlace",
                }
              : null,
          ].filter(Boolean), // remove null if no marketplace data
        };
      });

      // weeksObjCopy now has AWS + Marketplace services per week
      this.graph = weeksObjCopy;

      // Emit monthly data
      this.monthlyData.emit({
        services: this.weeksObj,
        total: this.total,
        totser: this.servicesTable.length,
      });
    } catch (err) {
      console.error("Error fetching data:", err);
      this.servicesTable = [];
      this.filteredList = [];
      this.weekHeaders = [];
      this.market_servicesTable = [];
      this.market_filteredList = [];
      this.market_weekHeaders = [];
      this.market_total = 0;
    } finally {
      this.notifier.loading(false);
    }
  }

  private baseParams(accountIds: string | string[]): Record<string, any> {
    const [month, year] = this.monthYear.split("-");
    return { account_ids: accountIds, year, month };
  }

  async loadPreferences(filteredQuery: any): Promise<void> {
    this.filteredTag =
      filteredQuery?.tag_key && filteredQuery?.tag_value
        ? {
            accountId: filteredQuery.account_ids,
            tagKey: filteredQuery.tag_key,
            tagValue: filteredQuery.tag_value,
          }
        : null;
    const { mode, ...queryWithoutMode } = filteredQuery;

    await this.fetchAndBind(queryWithoutMode);

    if (mode) {
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { mode },
        queryParamsHandling: "merge",
        replaceUrl: true,
      });
    }
    this.searchSubscription = this.searchSubject
      .pipe(debounceTime(300))
      .subscribe((searchText) => {
        this.applyFilter(searchText);
      });

    this.market_searchSubscription = this.market_searchSubject
      .pipe(debounceTime(300))
      .subscribe((searchText) => {
        this.market_applyFilter(searchText);
      });

    this.deepcopy();
  }

  async load(): Promise<void> {
    const params = this.baseParams(this.accountId);
    params["type"] = this.selectedView;
    await this.fetchAndBind(params);
    this.searchSubscription = this.searchSubject
      .pipe(debounceTime(300))
      .subscribe((searchText) => {
        this.applyFilter(searchText);
      });

    this.market_searchSubscription = this.market_searchSubject
      .pipe(debounceTime(300))
      .subscribe((searchText) => {
        this.market_applyFilter(searchText);
      });
    // this.filteredList = [...this.servicesTable];
    this.deepcopy();
  }

  activeBreakpoints: any;

  handlePreferencesResponse(data: any) {
    this.gear = false;
    this.isExpandedAll = false;

    this.activeBreakpoints = Object.keys(
      data.preferences?.breakpoints ?? {}
    ).filter((key) => data.preferences.breakpoints[key]);

    if (data.preferences?.breakpointsChanged) {
      let params: Record<string, any> = {
        ...this.baseParams(this.accountId),
      };

      if (this.activeBreakpoints.length > 0) {
        params = {
          ...params,
          mode: "preferences",
          breakup: this.activeBreakpoints,
        };
      } else {
        const { mode, breakup, ...rest } = params;
        params = rest;
      }

      this.fetchAndBind(params);
    }

    if (data.preferences) {
      this.preferencesData = data.preferences;
      this.usagePagination = data.preferences.usagePagination;
      this.breakpoints = data.preferences.breakpoints;
      this.selectedAccountIds = data.preferences.selectedAccountIds;
    } else {
      console.log("No preferences found in response");
    }
    if (data.services) {
      this.filteredList = data.services.map(
        (s: any): WeeklyPaginatedService => ({
          product_name: s.product_name || s.serviceName, // ✅ add this
          service_name: s.serviceName, // convert Service.serviceName → WeeklyPaginatedService.service_name
          costs: s.costs || [],
          regions: (s.regions || []).map((r: any) => ({
            region: r.region,
            costs: r.costs || [],
            product_families: (r.product_families || []).map((pf: any) => ({
              name: pf.name || pf.product_family,
              costs: pf.costs || [],
            })),
            expanded: false,
          })),
          expanded: false,
        })
      );
    } else {
      this.filteredList = [];
    }

    this.currentPage = 1;
    this.market_currentPage = 1;
  }

  async onTagsFiltered({
    accountId,
    tagKey,
    tagValue,
  }: {
    accountId: any;
    tagKey: string;
    tagValue: string;
  }): Promise<void> {
    this.isExpandedAll = false;
    this.filteredTag = { accountId, tagKey, tagValue };
    this.preferencesData = this.getDefaultPreferences(accountId);

    const params = {
      ...this.baseParams(accountId),
      tag_key: tagKey,
      tag_value: tagValue,
      mode: "filter",
    };
    await this.fetchAndBind(params);
  }

  get marketPaginatedList() {
    return this.monthexp.paginate(
      this.market_filteredList,
      this.market_currentPage,
      this.market_selectedPageSize
    );
  }

  get paginatedList() {
    return this.monthexp.paginate(
      this.filteredList,
      this.currentPage,
      this.selectedPageSize
    );
  }

  get totalPages() {
    return this.monthexp.totalPages(this.filteredList, this.selectedPageSize);
  }

  goToNextPage() {
    this.currentPage = this.monthexp.nextPage(
      this.currentPage,
      this.totalPages
    );
  }

  goToPreviousPage() {
    this.currentPage = this.monthexp.prevPage(this.currentPage);
  }

  get marketTotalPages() {
    return this.monthexp.totalPages(
      this.market_filteredList,
      this.market_selectedPageSize
    );
  }

  marketNext() {
    this.market_currentPage = this.monthexp.nextPage(
      this.market_currentPage,
      this.marketTotalPages
    );
  }

  marketPrev() {
    this.market_currentPage = this.monthexp.prevPage(this.market_currentPage);
  }

  clearTagFilter() {
    this.filteredTag = null;
    this.preferencesData = this.getDefaultPreferences();
    this.load();
  }

  toggle(item: any) {
    item.expanded = !item.expanded;
  }

  searchSubject: Subject<string> = new Subject<string>();
  searchSubscription!: Subscription;

  market_searchSubject: Subject<string> = new Subject<string>();
  market_searchSubscription!: Subscription;

  onSearch() {
    this.searchSubject.next(this.searchTerm);
  }

  market_onSearch() {
    this.market_searchSubject.next(this.market_searchTerm);
  }

  private filterServices(
    list: WeeklyPaginatedService[],
    text: string
  ): WeeklyPaginatedService[] {
    const filterText = text.trim().toLowerCase();
    if (!filterText) return [...list];
    return list.filter((s) =>
      (s.service_name || "").toLowerCase().includes(filterText)
    );
  }

  applyFilter(text: string) {
    this.filteredList = this.filterServices(this.servicesTable, text);
  }

  market_applyFilter(text: string) {
    this.market_filteredList = this.filterServices(
      this.market_servicesTable,
      text
    );
  }

  trackByService(index: number, item: WeeklyPaginatedService): string {
    return item.service_name;
  }

  private getDefaultPreferences(accountIds: any[] = []): any {
    return {
      pageSize: 20,
      wrapLines: false,
      usagePagination: true,
      visibleColumns: {
        description: true,
        usageQuantity: true,
        amountUsd: true,
      },
      breakpoints: {
        region: false,
        product_family: false,
        line_item: false,
      },
      selectedAccountIds: accountIds,
    };
  }

  onViewChange() {
    this.load();
  }
}
